import { db } from "common/config/Firebase"
import BusEvent from "common/services/BusEvent"

const invoiceCollection = db.collection('invoices')
const invoicesCreationCollection = db.collection('invoicesCreation')

const deleteInvoiceUseCase = async (invoice) => {
    const snapshot = invoiceCollection.doc(invoice.id).delete()
    await invoicesCreationCollection.doc(invoice.id).delete()
    BusEvent.publish(BusEvent.DELETE_INVOICE, invoice)
    return snapshot
}

export default deleteInvoiceUseCase